import { Pagination } from '../../../models/Pagination';
import { ProductFilter, ProductsResponseOut } from '../../store/api';
import { libraryManagedConfig } from '../../config';
import { http } from '../axios';

export const fetchLibraryManagedProductGroupProducts = async (
    productGroupId: string,
    { pagination, filterMap }: { pagination: Pagination; filterMap?: ProductFilter }
) => {
    const response = await http.post<ProductsResponseOut>(
        libraryManagedConfig().endpointProductGroupProducts,
        filterMap,
        {
            params: pagination,
            pathParams: { productGroupId }
        }
    );

    return response.data;
};
